import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMapSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10035_24984",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10035_24984)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.91338 16.6889C3.66768 16.7841 3.44012 16.7569 3.23067 16.6073C3.02123 16.4577 2.9165 16.2531 2.9165 15.9935V5.06415C2.9165 4.89956 2.9606 4.75186 3.0488 4.62102C3.13685 4.49019 3.26053 4.3954 3.41984 4.33665L7.49984 2.94873L12.4998 4.69873L16.0863 3.31102C16.332 3.21588 16.5596 3.23908 16.769 3.38061C16.9784 3.52213 17.0832 3.72005 17.0832 3.97436V10.2821C16.9176 10.0535 16.7298 9.84324 16.5198 9.65144C16.31 9.45963 16.0811 9.29054 15.8332 9.14415V4.74998L13.1248 5.77248V8.42956C12.9026 8.43484 12.6887 8.4538 12.483 8.48644C12.2774 8.51894 12.0747 8.57047 11.8748 8.64102V5.77248L8.12484 4.46144V15.0689L3.91338 16.6889ZM4.1665 15.25L6.87484 14.2114V4.46144L4.1665 5.37498V15.25ZM13.285 15.0881C13.7946 15.0881 14.2191 14.9292 14.5584 14.6114C14.8975 14.2935 15.0714 13.8541 15.08 13.2933C15.0885 12.7836 14.9189 12.357 14.5711 12.0135C14.2233 11.67 13.7946 11.4983 13.285 11.4983C12.7755 11.4983 12.3489 11.67 12.0055 12.0135C11.662 12.357 11.4903 12.7836 11.4903 13.2933C11.4903 13.8029 11.662 14.2294 12.0055 14.5729C12.3489 14.9164 12.7755 15.0881 13.285 15.0881ZM13.285 16.3381C12.4485 16.3381 11.7319 16.0398 11.1353 15.4431C10.5386 14.8464 10.2403 14.1298 10.2403 13.2933C10.2403 12.4568 10.5386 11.7402 11.1353 11.1435C11.7319 10.5467 12.4485 10.2483 13.285 10.2483C14.1216 10.2483 14.8382 10.5467 15.4348 11.1435C16.0315 11.7402 16.3298 12.4568 16.3298 13.2933C16.3298 13.6073 16.2877 13.9041 16.2034 14.1835C16.1189 14.4628 15.995 14.7221 15.8315 14.9614L17.9165 17.0385L17.0463 17.9166L14.9613 15.8316C14.722 16.0005 14.4627 16.1271 14.1834 16.2114C13.9039 16.2959 13.6045 16.3381 13.285 16.3381Z",
			fill: "currentColor"
		})
	})]
});
export default SvgMapSearch;
